import React from 'react';
import { useKeycloakContext } from '../contexts/AuthContext';
import keycloak from '../Keycloak';
import {Modal} from "../components/Modal";
import Button from './ergo-elements/components/Button';

export const SessionExpiredModal = () => {
  const { showSessionExpiredModal, setShowSessionExpiredModal } = useKeycloakContext();
  const handleLogout = () => {
    setShowSessionExpiredModal(false);
    keycloak.logout();
  };
  
  return (
    <Modal
      open={showSessionExpiredModal}
      onClose={handleLogout}
      title="Session Expired"
      dismissible
      onDismiss={handleLogout}
    >
      <div style={{ padding: '0 20px 20px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <p>Your session has expired. You will be disconnected.</p>
        <Button onClick={handleLogout}>Disconnect</Button>
      </div>
    </Modal>
  );
};

export default SessionExpiredModal;
